<template>
    <div>
        <QCard flat class="QCard">
            <QTabs
                v-model="tab"
                animated
                noCaps
                transitionNext="fade"
                transitionPrev="fade"
                class="ResourceTabs text-grey-8"
                activeColor="primary"
                indicatorColor="primary"
                align="justify"
            >
                <QTab
                    v-for="(attribute, index) in localAttributes"
                    :key="index"
                    :name="attribute.name"
                    :label="attribute.name"
                />
            </QTabs>
            <QSeparator />
            <QTabPanels
                v-model="tab"
                animated
                style="flex-grow: 1;"
            >
                <QTabPanel
                    v-for="(attribute, index) in localAttributes"
                    :key="index"
                    class="TabPanel"
                    :name="attribute.name"
                    :label="attribute.name"
                >
                    <PerformanceByResource
                        v-if="selectedOptions"
                        :tab="tab"
                        :selectedOptions="selectedOptions"
                    />
                </QTabPanel>
            </QTabPanels>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import PerformanceByResource from './PerformanceByResource.vue'

export default {
    name: 'PerformanceDashboardByResource',
    components: {
        PerformanceByResource,
    },
    props: {
        selectedOptions: VueTypes.object,
        attributes: VueTypes.array,

    },
    data() {
        return {
            tab: this.attributes.length > 0 ? this.attributes[0].name : '',
        }
    },
    computed: {
        localAttributes() {
            return this.attributes.map((attribute) => ({ ...attribute }))
        },
    },
    watch: {
        attributes: {
            immediate: true,
            handler(newAttributes) {
                if (newAttributes.length > 0) {
                    this.tab = newAttributes[0].name
                }
            },
        },
    },
    methods: {},
}
</script>
<style scoped lang="scss">
.QCard {
    height: 100%;
    display: flex;
    flex-direction:column;
}
.ResourceTabs {
    padding: 0 16px;

    :deep(.q-tab__label) {
        letter-spacing: 1.25px;
    }
}
</style>
